module.exports = __webpack_public_path__ + "img/music-ai-hover.c8df9ea8.png";